module.exports = __webpack_public_path__ + "img/mpe4.43ab3ad4.jpg";